import { render, staticRenderFns } from "./freespin-multiplier.vue?vue&type=template&id=3f3c6516&scoped=true&"
import script from "./freespin-multiplier.vue?vue&type=script&lang=js&"
export * from "./freespin-multiplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c6516",
  null
  
)

export default component.exports